import { faArrowUpRightAndArrowDownLeftFromCenter } from '@fortawesome/pro-light-svg-icons';
import { UTCTimestamp } from 'lightweight-charts';
import { memo, useMemo } from 'react';

import { Widget } from '../../../../../components/v2/widget';
import { ChartTypeEnum } from '../../../../../model/chart_type.enum';
import { PortfolioPerformanceChartType } from '../../../../portfolio-performance/components/portfolio-perfomance-chart-type';
import { BacktesterPnlReportRow } from '../../../../../providers/backtesting/api/backtester-config-api.types';

import { buildLineSeriesData } from './helpers';

interface SpotPriceChartProps {
  reports: BacktesterPnlReportRow[];
  token: string;
}

// Single series (token spot), so it uses the shared PortfolioPerformanceChartType
// — the same chart AccountEquity renders — rather than the bespoke multi-series
// MarketDataChart wrapper (which the still-multi-series ATM-vols / perp-spread
// charts keep). Perfectly consistent with Account Equity's look and its hover
// tooltip, not just similar.
export const SpotPriceChart = memo(({ reports, token }: SpotPriceChartProps) => {
  const data = useMemo(
    () =>
      buildLineSeriesData(reports, (row) => row.spot).map((point) => ({
        time: point.time as UTCTimestamp,
        value: point.value,
      })),
    [reports],
  );

  return (
    <Widget cardKey="market-data-spot-price-chart">
      <Widget.Header>
        <Widget.Title title={`${token} Spot Price`} />
        <Widget.Buttons>
          <Widget.Button icon={faArrowUpRightAndArrowDownLeftFromCenter} onClick={() => {}} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <PortfolioPerformanceChartType
          type={ChartTypeEnum.Line}
          data={data}
          precision={0}
          showTooltip
        />
      </Widget.Content>
      <Widget.Footer />
    </Widget>
  );
});

SpotPriceChart.displayName = 'SpotPriceChart';
